import React  from 'react'
import Modal from 'components/modal'

const GenerateSchedulerLinkModal = props => {
    return (
    <Modal
        title={props.displayError ? props.t('moderator.availibility.needed') : props.t('moderator.availibility.warning') }
        isOpen={props.isOpen}
        className={`confirmation-modal generate-scheduler-link-modal ${props.displayError ? 'display-error' : ''}`}
        type="modal"
        autoFocusSubmit={false}
        submitBtnText={props.t('generate.link')}
        onCancel={props.onClose}
        onSubmit= {props.onSubmit}
        isSubmitting= {props.isSubmitting}
        showSubmitBtn = {props.displayError ? false : true}
        cancelBtnText = {props.displayError ? props.t('ok') : props.t('cancel')}
      >
        <div className="generate-scheduler-link-modal-body">
          <div className="generate-scheduler-link-modal-text">
            <p>
              {<p className='manage-moderator-page' dangerouslySetInnerHTML={{
                __html: props.displayError ? props.t('generate.scheduler.link.error', {
                  markup: { tagStart: `<span> ${props.postScreeninBuffer} </span>` }
                }) : props.t('generate.scheduler.link.warning', {
                  markup: { tagStart: `<span> ${props.postScreeninBuffer} </span>` }
                })
              }} />
              }
            </p>
          </div>
        </div>
      </Modal>
    )
}

export default GenerateSchedulerLinkModal
